import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import getPage from "~/helpers/getPage"
import Materials from "~/views/documents"

const getInitialProps: GetInitialPropsType = async ({ req, query: { ...query } }) => {
  const apiContext = await getApiContext(
    [
      {
        url: "/documents/elements",
        code: "materials",
        query: { items_per_page: 15, page_number: 1, ...query },
      },
    ],
    req ? req.headers.host : location.host,
  )

  const { name } = apiContext["/documents/elements"].response
  const crumbs = generateCrumbs(req?.url, name)

  return { apiContext, crumbs }
}

const Page = getPage(getInitialProps, Materials)

export default Page
